import { createFileRoute } from "@tanstack/react-router";

import { PromoCodePage } from "@/features/growth/pages";

export const Route = createFileRoute("/_app/growth/promo-codes/$promoId")({
  component: PromoCode,
});

function PromoCode() {
  const { promoId } = Route.useParams();
  return <PromoCodePage key={promoId} promoId={promoId} />;
}
